import { combineEpics } from 'redux-observable';
import initializeEpic from './initialize';
import updateEpic from './update';

// @ts-expect-error - No overload matches this call
export default combineEpics(updateEpic, initializeEpic);
